import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconPauseRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667m-3.333 6.587c-.81 0-1.466.656-1.466 1.466v10.56a1.466 1.466 0 1 0 2.932 0V10.72c0-.81-.656-1.466-1.466-1.466m6.666 0c-.81 0-1.466.656-1.466 1.466v10.56a1.466 1.466 0 1 0 2.932 0V10.72c0-.81-.656-1.466-1.466-1.466" /></svg>;
export default SvgIconPauseRoundedFilledSmall;